import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { LogoMark } from "./Logo";

const Badge = () => (
  <div className="absolute -left-1 sm:-left-10 bottom-16 w-28 h-28 sm:w-32 sm:h-32" style={{ transform: "translateZ(80px)" }}>
    <svg viewBox="0 0 100 100" className="spin-slow absolute inset-0 w-full h-full">
      <defs><path id="circ" d="M50,50 m-38,0 a38,38 0 1,1 76,0 a38,38 0 1,1 -76,0" /></defs>
      <circle cx="50" cy="50" r="49" fill="#071510" stroke="rgba(229,168,85,0.5)" />
      <text fill="#E5A855" style={{ fontFamily: "IBM Plex Mono", fontSize: 8.4, letterSpacing: 2.6 }}>
        <textPath href="#circ">HEALTH · LIFE · FUTURE · PROTECTED ·</textPath>
      </text>
    </svg>
    <div className="absolute inset-0 grid place-items-center"><LogoMark className="w-10 h-10" /></div>
  </div>
);

export const HeroFrame = ({ rx, ry }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.94 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 1.4, delay: 0.35, ease: [0.76, 0, 0.24, 1] }}
    className="relative mx-auto max-w-[460px] px-4 sm:px-0"
  >
    <motion.div style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }} className="relative">
      <div className="arch overflow-hidden aspect-[4/5] relative shadow-[0_40px_120px_-30px_rgba(0,0,0,0.8)] ring-1 ring-white/10">
        <motion.img initial={{ clipPath: "inset(100% 0% 0% 0%)", scale: 1.3 }} animate={{ clipPath: "inset(0% 0% 0% 0%)", scale: 1.1 }} transition={{ duration: 1.5, delay: 0.35, ease: [0.76, 0, 0.24, 1] }} src="/img/hero.jpg" alt="Couple walking through a sunlit field" className="w-full h-full object-cover" data-testid="hero-image" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_30%,transparent_35%,rgba(7,21,16,0.75)_100%)]" />
      </div>
      <div className="absolute -right-1 sm:-right-8 top-10 rounded-2xl bg-[#071510]/55 backdrop-blur-xl border border-white/20 px-5 py-4 text-[#FAF8F5]" style={{ transform: "translateZ(60px)" }} data-testid="hero-enrollment-card">
        <p className="font-mono-d text-[11px] uppercase tracking-[0.2em] text-[#E5A855]">ACA Open Enrollment</p>
        <p className="font-serif-d text-2xl mt-1">Nov 1 — Jan 15</p>
        <p className="text-xs text-[#F4F1EA]/75 mt-1">Most states · special periods apply</p>
      </div>
      <div className="absolute right-6 -bottom-6 rounded-2xl bg-[#FAF8F5] text-[#0B281E] px-5 py-4 flex items-center gap-3 shadow-xl" style={{ transform: "translateZ(40px)" }}>
        <ShieldCheck className="w-6 h-6 text-[#C88A35]" />
        <span className="text-sm font-semibold leading-tight">No-cost<br />plan review</span>
      </div>
      <Badge />
    </motion.div>
  </motion.div>
);
